module.exports = __webpack_public_path__ + "static/media/12UNCTAD13.09f83c89.jpg";